import React, { useState } from 'react';

import { Button, Icon } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import LogoutIcon from '@mui/icons-material/Logout';

export default function MenuButton({ onNavigate, onLogout }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="menu-button"
        variant='contained'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Menu
      </Button>
      <Menu
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => {
          onNavigate('transactions');
          handleClose();
        }}><AutoStoriesIcon sx={{ marginRight: 1 }} />Livre-Journal</MenuItem>
        <MenuItem onClick={() => {
          onNavigate('invoices');
          handleClose();
        }}><PointOfSaleOutlinedIcon sx={{ marginRight: 1 }} />Facturation</MenuItem>
        <MenuItem onClick={() => {
          onLogout();
          handleClose();
        }}><LogoutIcon sx={{ marginRight: 1 }} /> Déconnexion</MenuItem>
      </Menu>
    </div>
  );
}